import type { Middleware } from '@floating-ui/dom';

export const flipSizeFixMiddleware: Middleware = {
  name: 'flipSizeFix',
  fn: ({ middlewareData, rects }) => {
    if (middlewareData.flipSizeFix?.done) {
      return {};
    }
    return {
      data: { done: true },
      reset: {
        rects: {
          floating: {
            ...rects.floating,
            height: rects.floating.height + 1
          },
          reference: rects.reference
        }
      }
    };
  }
};
